import { Icon } from 'src/components/icon/Icon';
import { Box, IconButton } from 'src/components/mui';
import { useMenuContext } from '../../context';

type Props = {
  onOpen: () => void;
  onClose?: () => void;
  setMenuIsOpen: (menuIsOpen: boolean) => void;
  menuIsOpen: boolean;
  icon: string | React.ReactNode;
  hasBeenOpened: boolean;
  openOnHover?: boolean;
  active?: boolean;
  bgColor?: string;
  textColor?: string;
  isBM?: boolean;
  isFirst?: boolean;
  isLast?: boolean;
  customIcon: string;
};

export default function Button({
  onOpen,
  onClose,
  setMenuIsOpen,
  menuIsOpen,
  icon,
  hasBeenOpened,
  openOnHover,
  active,
  bgColor,
  textColor,
  isBM,
  isFirst,
  isLast,
  customIcon,
}: Props) {
  const { rtl } = useMenuContext();

  return (
    <Box
      onMouseEnter={
        openOnHover && !menuIsOpen
          ? () => {
              onOpen();
              setTimeout(() => {
                setMenuIsOpen(true);
              }, 300);
            }
          : undefined
      }
      sx={{
        ...(rtl && !hasBeenOpened
          ? {
              marginLeft: '16px !important',
            }
          : {}),
      }}
    >
      <IconButton
        sx={{
          background: bgColor,
          color: textColor || 'white',
          ...(!hasBeenOpened ? { width: '50px', paddingRight: '17px' } : {}),
          '&:hover': {
            background: bgColor,
            opacity: 0.8,
          },

          borderTopLeftRadius: isFirst ? '8px' : '0px',
          borderBottomLeftRadius: isLast ? '8px' : '0px',
          borderTopRightRadius: '0px',
          borderBottomRightRadius: '0px',
        }}
        onClick={active && !isBM ? onClose : onOpen}
      >
        {customIcon ? (
          <img src={customIcon} alt="custom-icon" width={24} height={24} />
        ) : active && !isBM ? (
          <Icon type="fas" icon="fa-xmark" color={textColor} />
        ) : typeof icon === 'string' ? (
          <Icon type="fas" icon={icon} color={textColor} />
        ) : (
          icon
        )}
      </IconButton>
    </Box>
  );
}
